namespace TabAurous.Purchase {
    export namespace ApprovalInService {
        export const baseUrl = 'Purchase/ApprovalIn';

        export declare function Create(request: Serenity.SaveRequest<ApprovalInRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ApprovalInRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ApprovalInRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ApprovalInRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetLineNo(request: Serenity.ServiceRequest, onSuccess?: (response: GetLineNoResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function PostedTransIdList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ApprovalInRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function APIImportApprovals(request: TransactionRequest, onSuccess?: (response: Common.APIImportResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Post(request: TransactionRequest, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function PartyList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ApprovalInRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Purchase/ApprovalIn/Create",
            Update = "Purchase/ApprovalIn/Update",
            Delete = "Purchase/ApprovalIn/Delete",
            Retrieve = "Purchase/ApprovalIn/Retrieve",
            List = "Purchase/ApprovalIn/List",
            GetLineNo = "Purchase/ApprovalIn/GetLineNo",
            PostedTransIdList = "Purchase/ApprovalIn/PostedTransIdList",
            APIImportApprovals = "Purchase/ApprovalIn/APIImportApprovals",
            Post = "Purchase/ApprovalIn/Post",
            PartyList = "Purchase/ApprovalIn/PartyList"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetLineNo', 
            'PostedTransIdList', 
            'APIImportApprovals', 
            'Post', 
            'PartyList'
        ].forEach(x => {
            (<any>ApprovalInService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
